import { v4 as uuidv4 } from 'uuid';
import { TeamsAndUsersList } from '../../settings/types/users-and-teams';
import { TeamMembersList } from '../types/phone-numbers';

const ISO_TO_COUNTRY_NAME: Record<string, string> = {
  US: 'United States',
  CA: 'Canada',
};

export const getCountryNameFromCode = (countryCode: string): string =>
  ISO_TO_COUNTRY_NAME[countryCode?.toUpperCase()] || countryCode;

export const getLabelForCountryCode = (countryCode: string) => {
  // Map ISO code to country name and phone code
  const isoToCountryAndPhone: Record<
    string,
    { name: string; phoneCode: string }
  > = {
    US: { name: 'United States', phoneCode: '+1' },
    CA: { name: 'Canada', phoneCode: '+1' },
  };

  const countryData = isoToCountryAndPhone[countryCode.toUpperCase()];

  if (countryData) {
    return `${countryData.name} (${countryData.phoneCode})`;
  }

  // Fallback: return the ISO code if not found
  return countryCode;
};

export const flattenTeamMembers = (
  teamsAndUsersList: TeamsAndUsersList[],
): TeamMembersList[] => {
  const seen = new Set<number>();
  const members: TeamMembersList[] = [];
  (teamsAndUsersList ?? []).forEach((team) => {
    (team.users ?? []).forEach((user) => {
      if (user.id && !seen.has(user.id)) {
        seen.add(user.id);
        members.push({
          id: user.id,
          name: (user.userName || '').trim(),
          email: user.email || '',
        });
      }
    });
  });
  return members.sort((a, b) => a.name.localeCompare(b.name));
};

const DIALER_SESSION_ID_KEY = 'dialer_unique_id';

export const getDialerSessionUniqueId = (): string => {
  const existing = sessionStorage.getItem(DIALER_SESSION_ID_KEY);
  if (existing) {
    return existing;
  }
  const uniqueId = uuidv4().replace(/-/g, '').substring(0, 5);
  sessionStorage.setItem(DIALER_SESSION_ID_KEY, uniqueId);
  return uniqueId;
};
